import {
  ADD_APPLESMSLINK_SUCCESS,
  DELETE_APPLESMSLINK_SUCCESS,
  GET_APPLESMSLINK_FAIL,
  GET_APPLESMSLINK_SUCCESS,
  UPDATE_APPLESMSLINK_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  applesmslink: [],
  total: 0,
  pagination: { page: 1, per_page: 10, search: "" },
  error: {},
};

const APPLESMSLINK = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_APPLESMSLINK_SUCCESS:
      return {
        ...state,
        applesmslink: action.payload.applesmslink,
        total: action.payload.total ?? state.total,
        pagination: {
          page: action.payload.page ?? state.pagination.page,
          per_page: action.payload.per_page ?? state.pagination.per_page,
          search: action.payload.search ?? state.pagination.search,
        },
      };

    case GET_APPLESMSLINK_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_APPLESMSLINK_SUCCESS:
      return {
        ...state,
        applesmslink: [...state.applesmslink, action.payload],
      };

    case UPDATE_APPLESMSLINK_SUCCESS:
      return {
        ...state,
        applesmslink: state.applesmslink.map((id) =>
          id.id === action.payload.id ? { id, ...action.payload } : id
        ),
      };

    case DELETE_APPLESMSLINK_SUCCESS:
      return {
        ...state,
        applesmslink: state.applesmslink.filter((id) => id.id !== action.payload),
      };

    default:
      return state;
  }
};

export default APPLESMSLINK;
